import { motion } from 'framer-motion';
import { useState } from 'react';

interface BlacksmithWorkshopProps {
  children: React.ReactNode;
}

export default function BlacksmithWorkshop({ children }: BlacksmithWorkshopProps) {
  const [flameIntensity, setFlameIntensity] = useState(0.5);

  return (
    <div className="relative min-h-screen bg-gradient-to-b from-gray-950 via-gray-900 to-black overflow-hidden">
      {/* Animated background flames */}
      <div className="fixed inset-0 pointer-events-none">
        {[...Array(5)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute bottom-0 left-0 right-0"
            style={{
              background: `radial-gradient(ellipse at ${20 + i * 20}% bottom, 
                rgba(255, 69, 0, ${0.3 + flameIntensity * 0.2}) 0%, 
                rgba(255, 140, 0, ${0.2 + flameIntensity * 0.15}) 30%, 
                transparent 70%)`,
              height: '60%',
            }}
            animate={{
              opacity: [0.6, 0.8, 0.6],
              scale: [1, 1.1, 1],
            }}
            transition={{
              duration: 2 + i * 0.3,
              repeat: Infinity,
              delay: i * 0.2,
            }}
          />
        ))}
      </div>

      {/* Anvil shadows */}
      <div className="fixed inset-0 pointer-events-none">
        {[...Array(3)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute"
            style={{
              bottom: `${10 + i * 30}%`,
              left: `${15 + i * 25}%`,
              width: '200px',
              height: '150px',
              background: 'radial-gradient(ellipse, rgba(0,0,0,0.4) 0%, transparent 70%)',
              borderRadius: '50%',
            }}
            animate={{
              opacity: [0.3, 0.5, 0.3],
            }}
            transition={{
              duration: 3,
              repeat: Infinity,
              delay: i * 0.5,
            }}
          />
        ))}
      </div>

      {/* Sparks effect */}
      <div className="fixed inset-0 pointer-events-none">
        {[...Array(20)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute w-1 h-1 bg-yellow-400 rounded-full"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
            }}
            animate={{
              y: [0, -100],
              x: [0, (Math.random() - 0.5) * 50],
              opacity: [1, 0],
              scale: [1, 0],
            }}
            transition={{
              duration: 1 + Math.random(),
              repeat: Infinity,
              delay: Math.random() * 2,
            }}
          />
        ))}
      </div>

      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>

      {/* Ambient lighting */}
      <div 
        className="fixed inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(circle at 50% 80%, rgba(255, 140, 0, 0.1) 0%, transparent 50%)',
        }}
      />
    </div>
  );
}






